var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookBarDateRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BookBarDate") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 996,
    height: 44,
    rx: 5
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.8%",
    y: "-15.9%",
    width: "101.6%",
    height: "136.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0719259511 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "book-bar-large",
    transform: "translate(-15.000000, -14.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-5"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "field-icons",
    transform: "translate(15.000000, 14.000000)",
    fill: "#FF0036"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,8 L11,6 L12,6 L12,8 L13,8 L13,9 L12,9 L12,11 L11,11 L11,9 L9,9 L9,11 L8,11 L8,9 L6,9 L6,11 L5,11 L5,9 L4,9 L4,8 L5,8 L5,6 L6,6 L6,8 L8,8 L8,6 L9,6 L9,8 L11,8 Z M3,1 L14,1 C15.1045695,1 16,1.8954305 16,3 L16,13 L16,13 C16,14.1045695 15.1045695,15 14,15 L3,15 L3,15 C1.8954305,15 1,14.1045695 1,13 L1,3 L1,3 C1,1.8954305 1.8954305,1 3,1 L3,1 Z M4,4 C3.44771525,4 3,4.44771525 3,5 L3,12 C3,12.5522847 3.44771525,13 4,13 L13,13 C13.5522847,13 14,12.5522847 14,12 L14,5 C14,4.44771525 13.5522847,4 13,4 L4,4 Z",
    id: "BookBarDate"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookBarDateRed);
export default __webpack_public_path__ + "static/media/BookBarDateRed.e761ff6a0f7f89b67e432df3f2e45d4a.svg";
export { ForwardRef as ReactComponent };